export const stringToBoolean = (value: string): boolean => String(value) === 'true'

export const stringIsBoolean = (value: string): boolean => (
  value === 'true' || value === 'false'
)

export const stringToList = (item: string): any => (
  item !== ''
    ? [item]
    : []
)

export const excerpt = (text: string, limit: number, sufix = '...'): string => {
  if (text.length < limit) return text

  return `${text.substring(0, limit)}${sufix}`
}

export const removeAccents = (text: string) => (
  text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
)

export const removeSpecialChars = (text: string) => (
  text.replace(/[^\w\s]/gi, '')
)

export const removeSpaces = (text: string) => (
  text.replace(/\s/g, '')
)

export const stringToCPF = (text: string) => (
  text.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
)

export const stringToCNPJ = (text: string) => (
  text.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$3')
)
